import {
  CALL_OUR_TEAM,
  HELP_AND_SUPPORT,
  HELP_SUPPORT,
} from "@/constants/index"

export const helpSupportAnalytics = (pageName, phoneNumber) => {
  return JSON.stringify({
    clickInternalLinks: "true",
    internalLinkPosition: HELP_SUPPORT,
    internalLinkZoneName: `${pageName}:${HELP_AND_SUPPORT}`,
    internalLinkURL: `tel:${phoneNumber}`,
    internalLinkName: `${phoneNumber}`,
    eventName: `${pageName}:${HELP_AND_SUPPORT}:${phoneNumber}`,
    internalLinkType: `${pageName}:${CALL_OUR_TEAM}`,
    eventType: "navigation",
    eventAction: `${pageName}:${HELP_AND_SUPPORT}:${phoneNumber}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
  })
}
